import { useEffect, useRef, useState } from 'react';
import './productscategory.scss'
import { Check, ChevronLeft } from 'lucide-react';
import { ProductCategory, SubCategory } from '../../interface/interfaces';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
// import { productCategories } from '../../services/mockData';
import { AnimatePresence, motion } from 'framer-motion';
import CategorySkeleton from '../SkeletonLoaders/CategorySkeleton';

type Prop = {
    isLoading: boolean,
    toggle: boolean,
    categories:ProductCategory[],
    setToggle: React.Dispatch<React.SetStateAction<boolean>>;
}

const ProductsCategory = ({ toggle, setToggle, isLoading, categories }: Prop) => {
    const navigate = useNavigate()
    const location = useLocation();
    const { category, subcategory } = useParams()



    const [categoryData, setCategoryData] = useState<ProductCategory[]>([])
    const [subCategoryData, setSubCategoryData] = useState<SubCategory[]>([])
    const [isAllProducts,setAllProducts]=useState(false)


    // pre-render selected based on category or Search query
    useEffect(() => {
        
        const loaded = categories.map((item) => ({ ...item }));

        // console.log('Loaded',loaded)

        const query = new URLSearchParams(location.search);
        const searchText = query.get('search');

        if (!searchText || searchText === '') {

            if (category && category !== '') {

                const id = loaded.findIndex((data) => data.tag === category);


                if (id !== -1) {
                    loaded[id].isSelected = true;

                    const subCategories = loaded[id].subCategory || [];
                    let processedSubCategories

                    if (subcategory) {
                        processedSubCategories = subCategories.map((sub) => ({
                            ...sub,
                            isSelected: sub.tag === subcategory,
                        }));
                    } else {
                        processedSubCategories = subCategories
                    }

                    setSubCategoryData(processedSubCategories);

                } else {
                    console.warn('Invalid category tag:', category);
                }
            } else {
                // const firstTag = loaded[0]?.tag;
                // if (firstTag) navigate(`./${firstTag}`);   
            }
        }

        setCategoryData(loaded);

        // console.log('Category',category)
        //  console.log('Sub Category',subcategory)

    // eslint-disable-next-line
    }, [category, subcategory, location.search,categories]);



    const mobileRef = useRef<HTMLDivElement>(null);


    useEffect(() => {

        const handleClickOutside = (event: MouseEvent) => {
            if (
                toggle &&
                mobileRef.current &&
                !mobileRef.current.contains(event.target as Node)
            ) {
                setToggle(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
        // eslint-disable-next-line 
    }, [toggle]);




    const handleCategorySelect = (id: number) => {
        const updated = categoryData.map((item, index) => ({
            ...item,
            isSelected: index === id,
        }));

        setCategoryData(updated);

        const selectedSubCategory = updated[id].subCategory || [];
        setSubCategoryData(selectedSubCategory);

        navigate(`/products/${updated[id].tag}`);
        setAllProducts(false)
    };


    const handleSubCategorySelect = (id: number) => {
        // console.log('Id Number',id)

        const updated = subCategoryData.map((item, index) => ({
            ...item,
            isSelected: index === id,
        }));

        // console.log('Updated',updated)

        setSubCategoryData(updated);

        // Get the currently selected category from state
        const selectedCategory = categoryData.find((cat) => cat.isSelected);
        const categoryTag = selectedCategory?.tag;

        if (categoryTag) {
            navigate(`/products/${categoryTag}/${updated[id].tag}`);
        }

    };

    const handleResetCategory=()=>{
        setAllProducts(true)

         const updated = categoryData.map((item, index) => ({
            ...item,
            isSelected: false,
        }));

        setCategoryData(updated);

        const selectedSubCategory:SubCategory[]= [];
        setSubCategoryData(selectedSubCategory);
        navigate(`/products`);
    }



    return (<div className='productscategory'>

        <div className='web'>
            <div className='category'>

                <div className='category_title'>

                    <div className='icon menu'></div>
                    <div>Shop by categories</div>
                </div>

                <AnimatePresence>
                    {/* Start Category*/}

                    {isLoading && (
                        <motion.div initial={{ opacity: 0 }}
                            animate={{ opacity: 1, transition: { duration: 0.5, ease: "easeOut" } }}
                            exit={{ opacity: 0 }}>
                            <CategorySkeleton></CategorySkeleton>
                        </motion.div>
                    )}

                    {!isLoading && (<motion.div className='categoryOpts' initial={{ opacity: 0 }}
                        animate={{ opacity: 1, transition: { duration: 0.5, ease: "easeOut" } }}
                        exit={{ opacity: 0 }}>

                        {categoryData.map((data, index) => (
                            <div className='eachCategory' key={index} onClick={() => handleCategorySelect(index)}>
                                <div className='c_pack'>
                                    <div className={`checkbox flex_center ${data.isSelected ? 'active' : ''}`} >
                                        <Check size={23} className='mark'></Check>
                                    </div>

                                    <div className='c_text'>{data.name}</div>
                                </div>

                            </div>
                        ))}

                        <div className='eachCategory' onClick={handleResetCategory}>
                                <div className='c_pack'>
                                    <div className={`checkbox flex_center ${isAllProducts ? 'active' : ''}`} >
                                        <Check size={23} className='mark'></Check>
                                    </div>

                                    <div className='c_text'>All Products</div>
                                </div>

                        </div>

                    </motion.div>)}

                    {/* End Category */}



                    {/* Start Sub Category */}

                    {subCategoryData.length >= 1 && (
                        <motion.div initial={{ opacity: 0, y: -10, height: 0 }}
                            animate={{
                                opacity: 1, y: 0, height: "auto", transition: {
                                    type: "spring",
                                    stiffness: 400,
                                    damping: 20,
                                    bounce: 0.3,
                                }
                            }}
                            exit={{
                                opacity: 0, y: -10, height: 0, transition: {
                                    type: "tween",
                                    duration: 0.2,
                                    ease: "easeOut",
                                }
                            }}>

                            <motion.div className='title' initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }} transition={{
                                    type: "tween",
                                    duration: 0.3,
                                    ease: "easeInOut"
                                }}>Sub-category</motion.div>


                            <div className='subCategoryOpts' >
                                {subCategoryData.map((eachSubcategory, idx) => (

                                    <div className='eachSubcategory' key={idx}
                                        onClick={() => handleSubCategorySelect(idx)}
                                    >

                                        <div className='twoFlex'>

                                            <div className='c_pack'>
                                                <div className={`checkbox flex_center ${eachSubcategory.isSelected ? 'active' : ''}`}>
                                                    <Check className='mark'></Check>
                                                </div>

                                                <div className='c_text'>{eachSubcategory.name}</div>
                                            </div>


                                            {/* {!eachSubcategory.lastChild && (<div className='arrDiv'>
                    {eachSubcategory.isSelected && (<motion.div layoutId='updownarr' transition={{ type: "spring", stiffness: 500, damping: 30 }}><ChevronUp></ChevronUp></motion.div>)}
                    {!eachSubcategory.isSelected && (<motion.div layoutId='updownarr' transition={{ type: "spring", stiffness: 500, damping: 30 }}><ChevronDown></ChevronDown></motion.div>)}
                </div>)} */}

                                        </div>

                                    </div>

                                ))}
                            </div>




                        </motion.div>


                    )}

                    {/* End Sub Category */}

                </AnimatePresence>

            </div>
        </div>


        <AnimatePresence mode='wait'>
           {toggle && ( <div className='overlay'>
                <motion.div className='mobile'

                initial={{ opacity: 0, x: -10, width: 0 }}
                animate={{
                    opacity: 1, x: 0, width: "280px", transition: {
                        // type: "spring",
                        // stiffness: 400,
                        // damping: 20,
                        // bounce: 0.3,

                        type: "tween",
                        duration: 0.2,
                        ease: "easeOut",
                    }
                }}
                exit={{
                    opacity: 0, x: -10, width: 0, transition: {
                        type: "tween",
                        duration: 0.2,
                        ease: "easeOut",
                    }
                }}
                ref={mobileRef}
            >

                <button className="close-button" onClick={() => setToggle(false)} >
                    {/* <X size={20}></X> */}
                    <ChevronLeft size={30}></ChevronLeft>
                </button>
                <div className='category'>

                    <div className='category_title'>

                        <div className='icon menu'></div>
                        <div>Shop by categories</div>
                    </div>


                    {/* Start Category*/}

                    {isLoading && (
                        <motion.div initial={{ opacity: 0 }}
                            animate={{ opacity: 1, transition: { duration: 0.5, ease: "easeOut" } }}
                            exit={{ opacity: 0 }}>
                            <CategorySkeleton></CategorySkeleton>
                        </motion.div>
                    )}

                    {!isLoading && (<motion.div className='categoryOpts' initial={{ opacity: 0 }}
                        animate={{ opacity: 1, transition: { duration: 0.5, ease: "easeOut" } }}
                        exit={{ opacity: 0 }}>

                        {categoryData.map((data, index) => (
                            <div className='eachCategory' key={index} onClick={() => handleCategorySelect(index)}>
                                <div className='c_pack'>
                                    <div className={`checkbox flex_center ${data.isSelected ? 'active' : ''}`} >
                                        <Check size={23} className='mark'></Check>
                                    </div>

                                    <div className='c_text'>{data.name}</div>
                                </div>

                            </div>
                        ))}


                        <div className='eachCategory' onClick={handleResetCategory}>
                                <div className='c_pack'>
                                    <div className={`checkbox flex_center ${isAllProducts ? 'active' : ''}`} >
                                        <Check size={23} className='mark'></Check>
                                    </div>

                                    <div className='c_text'>All Products</div>
                                </div>

                        </div>

                    </motion.div>)}

                    {/* End Category */}





                    {/* Start Sub Category */}

                    {subCategoryData.length >= 1 && (
                        <motion.div initial={{ opacity: 0, y: -10, height: 0 }}
                            animate={{
                                opacity: 1, y: 0, height: "auto", transition: {
                                    type: "spring",
                                    stiffness: 400,
                                    damping: 20,
                                    bounce: 0.3,
                                }
                            }}
                            exit={{
                                opacity: 0, y: -10, height: 0, transition: {
                                    type: "tween",
                                    duration: 0.2,
                                    ease: "easeOut",
                                }
                            }}>

                            <motion.div className='title' initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }} transition={{
                                    type: "tween",
                                    duration: 0.3,
                                    ease: "easeInOut"
                                }}>Sub-category</motion.div>


                            <div className='subCategoryOpts' >
                                {subCategoryData.map((eachSubcategory, index) => (

                                    <div className='eachSubcategory' key={index}
                                        onClick={() => handleSubCategorySelect(index)}
                                    >

                                        <div className='twoFlex'>

                                            <div className='c_pack'>
                                                <div className={`checkbox flex_center ${eachSubcategory.isSelected ? 'active' : ''}`}>
                                                    <Check className='mark'></Check>
                                                </div>

                                                <div className='c_text'>{eachSubcategory.name}</div>
                                            </div>


                                            {/* {!eachSubcategory.lastChild && (<div className='arrDiv'>
                    {eachSubcategory.isSelected && (<motion.div layoutId='updownarr' transition={{ type: "spring", stiffness: 500, damping: 30 }}><ChevronUp></ChevronUp></motion.div>)}
                    {!eachSubcategory.isSelected && (<motion.div layoutId='updownarr' transition={{ type: "spring", stiffness: 500, damping: 30 }}><ChevronDown></ChevronDown></motion.div>)}
                </div>)} */}

                                        </div>

                                    </div>

                                ))}
                            </div>




                        </motion.div>


                    )}

                    {/* End Sub Category */}

                </div>

                <div className='btn' onClick={() => setToggle(false)}>
                   Confirm
                </div>

            </motion.div>
            </div>)}
            
        </AnimatePresence>



    </div>)

}

export default ProductsCategory;